/**
 * Dispatches action to keep modal in an unclosable state
 * @returns {Object}
 */
export function modalKeepOpen() {
  return {
    type: "MODAL_KEEP_OPEN",
  };
}
